import { render, staticRenderFns } from "./tyokertymalaskuri-view.vue?vue&type=template&id=0b63f3f8&scoped=true&"
import script from "./tyokertymalaskuri-view.vue?vue&type=script&lang=ts&"
export * from "./tyokertymalaskuri-view.vue?vue&type=script&lang=ts&"
import style0 from "./tyokertymalaskuri-view.vue?vue&type=style&index=0&id=0b63f3f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b63f3f8",
  null
  
)

export default component.exports